<template>
  <div id="resetPassword" class="container">
    <SfBreadcrumbs
        :breadcrumbs="breadcrumbs"
        class="breadcrumbs desktop-only"
    />
    <div class="content">
      <sf-heading :description="$t('myProfile.passwordUpdate.tab.message')" :level=1 :title="$t('Reset your password')">
      </sf-heading>
      <PasswordResetForm :token="token" v-on:modal="resultModal"/>

    </div>
  </div>
</template>

<script>

import PasswordResetForm from '@/components/PasswordResetForm';
import {SfHeading, SfBreadcrumbs} from '@storefront-ui/vue';

export default {
  name: 'resetPassword',
  components: {
    PasswordResetForm,
    SfHeading,
    SfBreadcrumbs
  },
  data() {
    return {
      termsOfUse: '',
      loading: false,
      error: null,
      token: this.$router.history.current.query.token || null,
      breadcrumbs: [
        {
          text: this.$i18n.t('Home'),
          link: '/'
        },
        {
          text: this.$i18n.t('Reset your password'),
        }
      ]
    };
  },
  methods: {
    resultModal(status) {
      this.$store.dispatch('toggleResetModal', {
        open: true,
        status: status,
      });
    },
  }
};

</script>

<style lang="scss" scoped>
#resetPassword {
  max-width: var(--layout-max-width);
  margin: 0 auto;
  @include for-mobile {
  }

  .content {
    max-width: 80%;
    margin: 0 auto;
    @include for-mobile {
      max-width: 100%;
    }
  }
}

#return {
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
</style>
